import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface GetSamplePreviewInterface {
  appId: string
  category_1: string | null
  category_2: string | null
  category_3: string | null
  category_4: string | null
}

export const useGetSamplePreview = () => {
  const mutate = useMutation(({appId, category_1, category_2, category_3, category_4}: GetSamplePreviewInterface) => {
    return postAPI(`/template-api/getSampletemplatebycat/${appId}`,{
      category_1,
      category_2,
      category_3,
      category_4
    })
  })

  return mutate
}

export default useGetSamplePreview
